<script>
  import { store, bindAction } from '@store'
  import throttle from 'lodash/throttle'
  import attachScrollListener from 'cl-js-utils/attachScrollListener'
  import detachScrollListener from 'cl-js-utils/detachScrollListener'
  import { onMount, onDestroy } from 'svelte'
  import { urlSelector } from '@ducks/layout'
  import { getNextData, nextPageSelector, preloaderSelector } from '@ducks/nested'
  import ImgPreloader from '@components/ImgPreloader'

  let dataContainer, url, page, showPreloader = false

  const getNextDataBindAction = bindAction(getNextData)

  const scrollHandle = () => throttle(event => {
    if (page) {
      if (dataContainer.getBoundingClientRect().bottom < window.innerHeight) {
        // если в данный момент нету загрузки
        if (!showPreloader) {
          getNextDataBindAction({ page, url })
        }
      }
    }
  }, 200)
  const scrollHandleEvent = scrollHandle()
  onMount(() => {
    attachScrollListener(document, scrollHandleEvent)
  })
  onDestroy(() => {
    if (!store.isServer) {
      detachScrollListener(document, scrollHandleEvent)
    }
  })
  $: url = urlSelector($store)
  $: page = nextPageSelector($store)
  $: showPreloader = preloaderSelector($store)
</script>

<div class="data-container" bind:this={dataContainer}>
  <slot></slot>
  <div class:active={showPreloader} class="preloader d-flex justify-content-center">
    <ImgPreloader />
  </div>
</div>

<style>
  .preloader {
    margin-bottom: 50px;
    height: 0;
    overflow: hidden;
    transition: all 0.5s;
    will-change: height;
  }
  .preloader.active {
    height: 66px;
  }
</style>
